// extracted by mini-css-extract-plugin
export default {"page":"Unauthorized_page__gXgRP","card":"Unauthorized_card__nI+Q4","code":"Unauthorized_code__DPoPa","homeLink":"Unauthorized_homeLink__IeTTD"};